import { Typography } from '@/components/Typography';
import { Title } from '@portal_components/components/Title';

interface UserInfoLoadingProps {
  errorOccurred?: boolean;
}

export const UserInfoLoading = ({ errorOccurred }: UserInfoLoadingProps) => {
  return (
    <div>
      <div className="w-1/2 inline-block align-top">
        <div className="mx-10">
          <Title className="mt-7 mb-2" text="Welcome to the Stark Job Booking Portal" />
          {errorOccurred ? <Typography content="We could not validate your user credentials, please contact support." /> : <Typography content="Please wait whilst we verify your user credentials" />}
        </div>
      </div>
      <div className="inline-block w-1/2 h-screen bg-center bg-origin-content bg-cover" style={{ backgroundImage: 'url(/searchImagery.jpeg)' }}></div>
    </div>
  );
};
